/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, ReactNode } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS Base Styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import backgroundImage from "assets/images/bg-profile.jpeg";
import { useAppContext } from "context/app-context";
import { Box, Modal, Typography } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { updateUser } from "services/user-services";
import { UserDto } from "types";

function Header({ children }: { children?: ReactNode }): JSX.Element {

  const { user, setUser, handleMessage } = useAppContext()

  useEffect(() => {
    setEmail(user.email)
    setName(user.name)
  }, [user])

  const [open, setOpen] = useState(false)
  const [tabsOrientation, setTabsOrientation] = useState<"horizontal" | "vertical">("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>(user.email)
  const [password, setPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')


  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event: any, newValue: any) => setTabValue(newValue);
  const handleSaveUserData = async () => {
    if (password !== confirmPassword) {
      return handleMessage("Adgangskoder er ikke de samme", "error")
    }
    let updatedUser: UserDto
    try {
      updatedUser = await updateUser({ name: name || user.name, email, password })
      setUser(updatedUser)
      setOpen(!open)
      handleMessage("Du har opdateret dine brugerdata", "success")
    } catch (error) {
      console.error({ error })
      setOpen(!open)
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error.message, "error")
    }
  }
  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <Icon fontSize="large" sx={{ mt: -0.25 }}>
              person
            </Icon>
            {/* <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" /> */}
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {user.name}
              </MDTypography>
              <MDTypography variant="button" color="text" fontWeight="regular">
                {user.role}
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                {/* <Tab
                  label="App"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      home
                    </Icon>
                  }
                />
                <Tab
                  label="Message"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      email
                    </Icon>
                  }
                />*/}
                <Tab
                  onClick={() => setOpen(!open)}
                  label="Edit"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      edit
                    </Icon>
                  }
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
        {children}
      </Card>
      <Modal
        open={open}
        onClose={() => setOpen(!open)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edit your data
          </Typography>
          <Grid container spacing={3} alignItems="center" display="flex" flexDirection={"column"}>
            <Grid item xs={12} md={12} lg={12} sx={{ mx: "auto" }} display="flex">
              <MDBox pr={1} mt={2.5}>
                <MDInput value={name} onChange={(e: any) => setName(e.target.value)} label="Full Name" />
              </MDBox>

              <MDBox pr={1} mt={2.5}>
                <MDInput value={email} disabled onChange={(e: any) => setEmail(e.target.value)} label="email" type="email" />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ mx: "auto" }} display="flex">
              <MDBox pr={1} mb={2.5}>
                <MDInput value={password} onChange={(e: any) => setPassword(e.target.value)} label="Password" type="password" />
              </MDBox>

              <MDBox pr={1} mb={2.5}>
                <MDInput value={confirmPassword} onChange={(e: any) => setConfirmPassword(e.target.value)} label="Confirm Password" type="password" />
              </MDBox>
            </Grid>
            <MDButton onClick={handleSaveUserData} color='secondary' >
              Save
            </MDButton>
          </Grid>
        </Box>
      </Modal>
    </MDBox>
  );
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

// Declaring default props for Header
Header.defaultProps = {
  children: "",
};

export default Header;
